// extracted by mini-css-extract-plugin
export var copyableField = "_pp-4";
export var customerBadge = "_pp-0";
export var customerInfoTitle = "_pp-2";
export var details = "_pp-1";
export var dropdownContainer = "_pp-5";
export var dropdownImage = "_pp-6";
export var editAssigneeForm = "_pp-a";
export var editButton = "_pp-3";
export var email = "_pp-7";
export var hidden = "_pp-d";
export var input = "_pp-8";
export var saveButton = "_pp-b";
export var shopifyIcon = "_pp-c";
export var suggestionBadge = "_pp-e";
export var suggestionText = "_pp-f";
export var username = "_pp-9";